// @ts-nocheck
/* eslint-disable */
import dayjs from 'dayjs'
import {
    API_URL,
    FETCH_FREQUENCY,
    FETCH_TIMEOUT,
    FetchFrequencyType,
    UPCOMING_THRESHOLD_IN_MINUTES,
} from '../../config/statsperformConfig'
import type { MatchDetails } from './types'
import { fetchWithTimeout } from '../../shared/apiFetchWithTimeout'

// Todo : Remove all test code

export const fetchMatchDetails = async (matchId: string) => {
    const response = await fetchWithTimeout<{ match: MatchDetails[] }>(
        API_URL.matchDetails(matchId),
        { timeout: FETCH_TIMEOUT.matchDetails },
    )

    if ('errorCode' in response && response.errorCode) {
        throw new Error(`Error fetching match details ${response.errorCode}`)
    }

    if (!response?.match?.length) {
        throw new Error(`Fetched match is empty`)
    }

    return response.match[0]
}

export const formatToDayJsDate = (matchInfo: MatchDetails['matchInfo']) => {
    return dayjs(`${matchInfo.date.replace('Z', 'T')}${matchInfo.time}`)
}

export const getFetchFrequencyType = (match: MatchDetails): FetchFrequencyType => {
    //return 'liveMatch' // Use this to force during testing

    const status = match.liveData?.matchDetails.matchStatus
    if (status === 'Playing') return 'liveMatch'

    const matchStart = formatToDayJsDate(match.matchInfo)

    const isVeryUpcoming = dayjs().isBetween(
        matchStart.subtract(UPCOMING_THRESHOLD_IN_MINUTES.lower, 'minute'),
        matchStart.add(UPCOMING_THRESHOLD_IN_MINUTES.lower, 'minute'),
    )
    if (isVeryUpcoming) return 'liveMatch'

    const isUpcoming = dayjs().isBetween(
        matchStart.subtract(UPCOMING_THRESHOLD_IN_MINUTES.upper, 'minute'),
        matchStart.add(UPCOMING_THRESHOLD_IN_MINUTES.upper, 'minute'),
        // Tolerance of match is done on the two check. If a match is normally playing but not in live status,
        // we have a litle tolerance for "live update" and a bigger tolerance for 'isUpcoming update'.
    )
    if (isUpcoming) return 'upcomingMatch'

    return 'nonLiveMatch'
}

export const getFetchFrequency = (match: MatchDetails) =>
    FETCH_FREQUENCY[getFetchFrequencyType(match)]

export const getContestantObject = (
    contestant: Contestant | undefined,
    statsPerformCountries: StatsPerformCountry[],
) => {
    if (!contestant) return undefined

    const contestantOnJson = statsPerformCountries.find((e) => e.area_uuid === contestant.areaId)

    return {
        logo: `${(contestantOnJson?.EN ?? contestant.name ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')}`,
        // eslint-disable-next-line no-nested-ternary
        name: contestantOnJson
            ? contestantOnJson.FR !== 'NULL'
                ? contestantOnJson.FR
                : contestant.name ?? ''
            : contestant.name ?? '',
        contestantId: contestant.id,
    }
}
